export const validatePatientSurgicalHistory = (field, value) => {
  let errMsg = '';
  switch (field) {
    case 'procedure':
      if (!value) {
        errMsg = 'Procedure should not be empty';
      }
      break;
    default:
      errMsg = '';
  }

  return { [field]: errMsg };
};
